function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "252px",
    height: "80px",
    viewBox: "0 0 252 80",
    style: {
      enableBackground: "new 0 0 252 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A5BA9"
    },
    d: "M101.347,53.805h-9.563c-2.095,0-4.06-0.654-5.371-2.029c-1.375-1.376-2.029-3.274-2.029-5.372 h3.143c0,1.507,0.394,2.49,1.113,3.146c0.655,0.652,1.638,1.112,3.144,1.112h9.563c1.505,0,2.488-0.524,3.208-1.311 c0.786-0.917,1.899-4.714,0.327-5.304c-1.441-0.721-5.24-1.113-9.103-1.113c-5.24,0-8.514-0.853-10.218-2.62 c-2.554-2.554-1.768-7.99,0.917-10.349C87.854,28.655,89.688,28,91.522,28h9.562c4.126,0,7.205,3.21,7.401,7.401h-3.144 c0-2.423-1.768-4.191-4.258-4.257h-9.562c-1.047,0-2.162,0.393-2.947,1.113c-1.245,1.179-2.096,4.453-0.786,5.894 c0.786,0.722,2.75,1.639,7.99,1.639c6.025,0,8.776,0.262,10.413,1.049c2.556,1.178,2.556,3.731,2.556,5.435 C108.551,50.335,105.8,53.805,101.347,53.805z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A5BA9"
    },
    d: "M135.663,35.729v10.675c0,2.293-0.917,4.193-2.358,5.437c-1.375,1.311-3.21,1.965-5.043,1.965 h-9.496c-1.047,0-2.096-0.195-3.013-0.59v15.653h-3.078V28.067h3.078v0.786c0.917-0.395,1.965-0.591,3.013-0.591h9.496 c2.162,0,4.062,0.72,5.372,2.03C135.008,31.668,135.663,33.567,135.663,35.729z M132.519,35.729c0-1.507-0.392-2.554-1.049-3.208 c-0.719-0.656-1.7-1.113-3.208-1.113h-9.496c-1.376,0-2.292,0.457-3.013,1.047v17.159c0.786,0.654,1.768,1.048,3.013,1.113h9.496 c1.049,0,2.162-0.459,2.947-1.178c0.786-0.722,1.311-1.703,1.311-3.146V35.729z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A5BA9"
    },
    d: "M153.279,50.661v3.144h-4.454c-3.014,0-5.436-0.524-7.074-2.161 c-1.635-1.571-2.161-3.93-2.161-6.68v-32.42h3.144v32.42c0,4.452,1.572,5.633,6.091,5.697H153.279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A5BA9"
    },
    d: "M161.987,53.805c-4.389-0.195-7.401-3.078-7.401-7.401V35.467c0.132-4.191,3.341-7.399,7.401-7.399 h9.496c4.258,0.195,7.467,3.208,7.467,7.399v5.501h-21.22v5.436c0.131,2.751,1.638,4.258,4.257,4.258h9.496 c2.489-0.064,4.323-1.834,4.323-4.258h3.144c-0.327,4.323-3.274,7.401-7.4,7.401H161.987z M175.806,37.825v-2.358 c-0.064-2.555-1.833-4.257-4.323-4.257h-9.496c-2.487,0.197-4.257,1.834-4.257,4.257v2.358H175.806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A5BA9"
    },
    d: "M207.242,35.533v18.271h-3.143c0-0.195,0.065-0.457,0.065-18.271 c-0.065-1.442-0.59-2.423-1.376-3.21c-0.785-0.721-1.899-1.113-2.947-1.113h-9.496c-1.31,0-2.358,0.458-3.078,1.179 c-0.787,0.786-1.245,1.769-1.245,3.145v18.206h-3.144c0.064-0.263,0.064-0.589,0.064-18.206c0-2.097,0.72-3.996,2.096-5.307 c1.31-1.373,3.208-2.159,5.305-2.159h9.496c1.833,0.064,3.667,0.719,5.043,1.964C206.325,31.34,207.242,33.239,207.242,35.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A5BA9"
    },
    d: "M218.57,28.132h9.561c1.571,0,3.014,0.459,4.258,1.244V12.544h3.077 c0,22.923,0.131,22.792,0,41.261h-3.077v-1.506c-1.179,0.786-2.62,1.311-4.258,1.311h-9.561c-2.095,0-4.061-0.721-5.371-2.097 c-1.375-1.312-2.03-3.209-2.03-5.37V35.533c0-2.294,0.982-4.193,2.358-5.437C214.901,28.786,216.736,28.132,218.57,28.132z  M214.313,46.143c0.131,2.751,1.703,4.322,4.257,4.322h9.561c2.359-0.065,4.062-1.571,4.258-3.864V35.139 c-0.196-2.291-2.031-3.929-4.258-3.929h-9.561c-2.424,0.13-4.257,1.965-4.257,4.323V46.143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A5BA9"
    },
    d: "M239.46,28.067h3.144c-0.064,25.345-0.064,25.542-0.064,25.737h-3.08V28.067z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.46,
    y: 20.469,
    style: {
      fill: "#87B04B"
    },
    width: 3.014,
    height: 3.669
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 40,
    cy: 40,
    r: 30
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.333,
    y1: 52.46,
    x2: 30.8044,
    y2: 33.6868
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4413,
    style: {
      stopColor: "#5A5BA9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#444580"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9997,
    style: {
      stopColor: "#353563"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M63.833,21.777C67.702,26.828,70,33.146,70,40c0,15.648-11.98,28.499-27.27,29.878 l0.14-0.045c0.432-0.129,0.863-0.27,1.289-0.419c3.679-1.295,7.015-3.409,9.732-6.211c0.93-0.959,1.806-1.98,2.591-3.064 c0.372-0.445,0.686-0.96,0.989-1.453c0.689-1.115,1.259-2.308,1.697-3.544c1.632-4.604-1.059,2.984,0,0 c0.986-2.783,1.318-5.865,0.989-8.802c-0.395-3.522-2.662-6.604-5.386-8.75c-3.403-2.68-7.522-4.252-11.634-5.479 c-1.162-0.347-2.327-0.682-3.458-1.122c-1.013-0.394-2.074-0.858-2.866-1.626c-0.758-0.735-1.164-1.776-1.295-2.811 c-0.149-0.943,0.088-1.941,0.438-2.813c0.439-1.098,1.122-2.072,1.89-2.963c0.632-0.735,1.333-1.388,2.14-1.929 c0.72-0.483,1.487-0.896,2.272-1.265c0.274-0.129,0.831-0.361,0.831-0.361c0.413-0.163,0.835-0.306,1.266-0.424 c1.76-0.482,3.579-0.768,5.404-0.809c3.582-0.078,7.15,0.812,10.217,2.68c1.38,0.841,2.643,1.862,3.77,3.019L63.833,21.777z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M42.84,44.243c0,0,9.553,3.312,6.037,12.258c-2.347,5.973-9.354,8.439-9.354,8.439 s7.355-0.653,10.754-7.039c2.489-4.678,0.824-9.012-2.04-11.424C45.959,44.557,42.84,44.243,42.84,44.243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M37.373,35.52c0,0-9.552-3.311-6.036-12.257c2.347-5.974,9.353-8.439,9.353-8.439 s-7.354,0.653-10.753,7.039c-2.49,4.677-0.825,9.01,2.039,11.424C34.253,35.206,37.373,35.52,37.373,35.52z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.7612,
    y1: 41.4775,
    x2: 57.8169,
    y2: 36.9921
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3D4F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218,
    style: {
      stopColor: "#405424"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2038,
    style: {
      stopColor: "#5A7532"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3908,
    style: {
      stopColor: "#6E8F3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5824,
    style: {
      stopColor: "#7CA145"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7815,
    style: {
      stopColor: "#84AC49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#87B04B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M59.169,55.142c-0.438,1.236-1.008,2.429-1.697,3.544c-0.303,0.493-0.626,0.985-0.998,1.433 c0.391-0.809,0.818-1.593,1.172-2.421c0.417-0.976,0.681-2.037,0.889-3.077c0.226-1.124,0.332-2.281,0.317-3.427 c-0.014-1.217-0.093-2.471-0.333-3.666c-0.223-1.11-0.529-2.185-1.013-3.212c-0.494-1.048-1.143-2.019-1.913-2.883 c-1.554-1.748-3.572-3.055-5.637-4.118c-2.165-1.113-4.446-1.988-6.754-2.754c-2.212-0.735-4.538-1.38-6.489-2.705 c-0.904-0.614-1.69-1.402-2.178-2.39c-0.518-1.047-0.662-2.228-0.616-3.383c0.094-2.381,1.599-4.417,3.333-5.938 c1.135-0.994,2.482-1.726,3.87-2.299c0.765-0.317,1.554-0.599,2.36-0.792c-0.101,0.076-0.278,0.112-0.394,0.16 c-0.28,0.116-0.555,0.239-0.829,0.368c-0.785,0.368-1.552,0.781-2.272,1.265c-0.807,0.541-1.507,1.193-2.14,1.929 c-0.769,0.891-1.451,1.865-1.89,2.963c-0.349,0.872-0.587,1.87-0.438,2.813c0.131,1.034,0.538,2.075,1.295,2.811 c0.792,0.768,1.853,1.232,2.866,1.626c1.131,0.44,2.296,0.775,3.458,1.122c4.112,1.228,8.23,2.8,11.634,5.479 c2.724,2.146,4.991,5.228,5.386,8.75C60.488,49.276,60.155,52.358,59.169,55.142C58.11,58.126,60.802,50.538,59.169,55.142z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 7031.335,
    y1: -2289.5396,
    x2: 6994.8057,
    y2: -2308.3132,
    gradientTransform: "matrix(-1 0 0 -1 7044 -2262)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#87B04B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2185,
    style: {
      stopColor: "#84AC49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4176,
    style: {
      stopColor: "#7CA145"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6092,
    style: {
      stopColor: "#6E8F3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7962,
    style: {
      stopColor: "#5A7532"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9782,
    style: {
      stopColor: "#405424"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3D4F22"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    d: "M16.167,58.223C12.298,53.172,10,46.854,10,40c0-15.648,11.981-28.499,27.27-29.878 l-0.14,0.045c-0.432,0.129-0.863,0.27-1.289,0.419c-3.68,1.295-7.015,3.409-9.732,6.212c-0.929,0.958-1.805,1.979-2.59,3.063 c-0.373,0.445-0.686,0.96-0.99,1.453c-0.689,1.116-1.258,2.308-1.697,3.544c-1.632,4.604,1.059-2.984,0,0 c-0.986,2.784-1.318,5.865-0.989,8.802c0.395,3.522,2.662,6.604,5.387,8.75c3.402,2.68,7.521,4.253,11.633,5.479 c1.161,0.348,2.328,0.682,3.459,1.122c1.012,0.394,2.073,0.859,2.865,1.626c0.758,0.735,1.164,1.776,1.295,2.811 c0.149,0.943-0.089,1.942-0.437,2.813c-0.439,1.098-1.123,2.072-1.89,2.963c-0.633,0.735-1.333,1.388-2.141,1.929 c-0.72,0.483-1.487,0.896-2.272,1.265c-0.273,0.129-0.831,0.361-0.831,0.361c-0.413,0.163-0.834,0.306-1.266,0.424 c-1.76,0.484-3.578,0.768-5.403,0.809c-3.582,0.078-7.151-0.812-10.218-2.68c-1.379-0.841-2.643-1.862-3.77-3.019L16.167,58.223z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 6999.7617,
    y1: -2300.5225,
    x2: 7021.8179,
    y2: -2305.0081,
    gradientTransform: "matrix(-1 0 0 -1 7044 -2262)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00031891,
    style: {
      stopColor: "#353563"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#444580"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5587,
    style: {
      stopColor: "#5A5BA9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_4_)"
    },
    d: "M20.831,24.858c0.439-1.236,1.008-2.428,1.697-3.544c0.304-0.493,0.626-0.985,0.999-1.433 c-0.392,0.809-0.819,1.593-1.172,2.421c-0.417,0.976-0.682,2.037-0.89,3.077c-0.225,1.124-0.331,2.281-0.317,3.427 c0.014,1.217,0.094,2.471,0.333,3.666c0.223,1.11,0.529,2.185,1.013,3.212c0.493,1.048,1.143,2.019,1.913,2.883 c1.554,1.748,3.571,3.055,5.638,4.118c2.165,1.113,4.445,1.988,6.753,2.755c2.212,0.734,4.538,1.379,6.489,2.704 c0.904,0.614,1.691,1.402,2.179,2.39c0.517,1.047,0.66,2.228,0.616,3.383c-0.094,2.381-1.599,4.417-3.334,5.938 c-1.134,0.994-2.481,1.726-3.87,2.299c-0.765,0.317-1.554,0.599-2.359,0.792c0.1-0.076,0.277-0.112,0.394-0.16 c0.279-0.116,0.555-0.239,0.828-0.368c0.785-0.368,1.552-0.781,2.272-1.265c0.808-0.541,1.507-1.193,2.141-1.929 c0.768-0.891,1.451-1.865,1.89-2.963c0.348-0.871,0.586-1.87,0.437-2.813c-0.131-1.034-0.538-2.075-1.295-2.811 c-0.792-0.767-1.853-1.232-2.865-1.626c-1.131-0.44-2.298-0.774-3.459-1.122c-4.112-1.227-8.23-2.8-11.633-5.479 c-2.725-2.146-4.992-5.228-5.387-8.75C19.512,30.724,19.845,27.643,20.831,24.858C21.89,21.874,19.198,29.463,20.831,24.858z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.04d9e2cc8bcbad13628e09df3b638ba0.svg";
export { ForwardRef as ReactComponent };